import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { ChatSection, ChatSectionTitle } from "../ChatSearch/ChatSearchResult";
import ChatReportDetailModal from "./ChatReportDetailModal/ChatReportDetailModal";
import { IChatReportComplete } from "./ReportComplete";
import { toast } from "react-toastify";
import Pagination from "../../../../Table/Pagination";
import { isNewChat } from "../../../../../pages/Party/ChatInfo";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export const reportReasonList = [
  {
    id: 0,
    text: "개인 정보 노출 및 요구",
  },
  {
    id: 1,
    text: "욕설 및 혐오 표현",
  },
  {
    id: 2,
    text: "성희롱, 음담패설",
  },
  {
    id: 3,
    text: "도박, 사행성 등 불법 정보",
  },
  {
    id: 4,
    text: "채팅 도배",
  },
  {
    id: 5,
    text: "기타 (직접 입력)",
  },
];

export default function ChatReport() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [reportDetailModal, setReportDetailModal] = useState(false);
  const [detailData, setDetailData] = useState<IChatReportComplete>({
    id: "",
    msgList: [],
    user: {
      name: "",
      nickname: "",
      uid: "",
    },
    uid: {
      name: "",
      nickname: "",
      uid: "",
    },
    party: {
      partyid: "",
      servsubsid: 0,
      ownerid: "",
    },
    reason: "",
    reasonid: 0,
    target: {
      uid: "",
      name: "",
      nickname: "",
    },
    time: "",
    comptime: "",
    comment: "",
    admin: "",
    adminId: "",
  });

  const chatReportTableHead = [
    "신고자",
    "PID",
    "Subscription",
    "사유 구분",
    "신고 일시",
    "상세 및 접수",
  ];

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.chat
      ? `${isNewChat ? "chat" : "oldchat"}/report?page=${page}&size=5&state=0`
      : undefined,
  });

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "채팅 신고 내역 조회에 실패하였습니다.");
    }
  }, [error]);

  return (
    <ChatSection>
      <ChatSectionTitle>채팅 신고</ChatSectionTitle>

      <LineBox>
        <Table tableHeadData={chatReportTableHead}>
          <>
            {response?.data?.items?.map(
              (d: IChatReportComplete, index: number) => {
                return (
                  <TableBody key={index}>
                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/users/info/${d?.user?.uid}`)}
                    >
                      {d?.user?.uid}_{d?.user?.name}_{d?.user?.nickname}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() =>
                        navigate(`/party/info/${d?.party?.partyid}`)
                      }
                    >
                      {d?.party?.partyid}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.party?.servsubsid}_
                      {getSubsNameBySubsId3(d?.party?.servsubsid)}
                    </TableBodyItem>
                    <TableBodyItem>
                      {
                        reportReasonList?.find((r) => r.id === d?.reasonid)
                          ?.text
                      }
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="상세 내용 및 접수"
                        btnClickEvent={() => {
                          setDetailData(d);
                          setReportDetailModal(true);
                        }}
                        disabled={!auth?.chat}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              }
            )}

            {reportDetailModal && (
              <ChatReportDetailModal
                closeEvent={() => setReportDetailModal(false)}
                comfirmEvent={() =>
                  fetchData({
                    method: "get",
                    url: auth?.chat
                      ? `${
                          isNewChat ? "chat" : "oldchat"
                        }report?page=0&size=5&state=0`
                      : undefined,
                  })
                }
                data={detailData}
              />
            )}
          </>
        </Table>

        <Pagination
          totalPage={response?.status === 200 ? response.data.totalPage : 0}
          currentPage={page}
          pageClickEvent={(index) => setPage(index)}
          pageSize={response?.status === 200 ? +response?.data?.pageSize : 0}
        />
      </LineBox>

      {loading && <Loader />}
    </ChatSection>
  );
}
